import * as React from "react";
const CalendarIcon = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8 2v3m8-3v3m4.75 12.6H3.25M16 3.5c3.33.18 5 1.45 5 6.15v6.18c0 4.12-1 6.18-6 6.18H9c-5 0-6-2.06-6-6.18V9.65c0-4.7 1.67-5.96 5-6.15z"
            stroke={props.color || "#465050"}
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 8.75c.53 0 .976.145 1.278.388.29.232.482.579.482 1.082 0 .443-.19.755-.514.978l-.658.454.696.394c.47.265.716.693.716 1.185 0 .478-.179.833-.485 1.08-.32.256-.822.43-1.515.43-.698 0-1.2-.175-1.518-.43-.304-.246-.482-.6-.482-1.08 0-.49.244-.913.714-1.19l.679-.4-.652-.444a1.13 1.13 0 0 1-.51-.977c0-.502.193-.849.485-1.081.305-.244.754-.389 1.284-.389Zm0 2.9c-.403 0-.806.097-1.121.338a1.32 1.32 0 0 0-.519 1.082c0 .449.187.829.516 1.084.314.245.717.346 1.124.346s.81-.101 1.124-.346c.329-.255.516-.635.516-1.084 0-.446-.19-.824-.517-1.077-.313-.242-.716-.343-1.123-.343ZM12 9c-.349 0-.697.097-.968.325-.28.236-.432.578-.432.965 0 .384.153.724.427.962.268.231.616.338.973.338s.706-.107.973-.338a1.25 1.25 0 0 0 .427-.962c0-.387-.152-.729-.432-.965C12.698 9.097 12.348 9 12 9Z"
            fill={props.color || "#465050"}
            stroke={props.color || "#465050"}
        />
    </svg>
);
export default CalendarIcon;
